import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "m3.531 12.76-1.27 1.27a.75.75 0 1 1-1.06-1.06L12.898 1.273a.75.75 0 0 1 1.06 1.06l-1.197 1.198a5.31 5.31 0 0 1 .591 2.408v4.112c0 .706.582 1.279 1.288 1.279h.038a.72.72 0 0 1 .716.715.72.72 0 0 1-.716.716H10.71A2.717 2.717 0 0 1 8 15.394a2.717 2.717 0 0 1-2.71-2.633H3.531Zm8.16-8.158c.157.417.245.868.25 1.337v4.112c0 .458.114.897.324 1.279H4.963l6.728-6.728ZM8 13.962a1.29 1.29 0 0 1-1.278-1.201h2.556A1.29 1.29 0 0 1 8 13.963Z",
  "clip-rule": "evenodd"
}, null, -1), l = /* @__PURE__ */ e("path", { d: "M8.01 2.037a3.956 3.956 0 0 1 1.847.474l1.04-1.04a5.358 5.358 0 0 0-2.82-.865h-.144c-2.91.057-5.266 2.423-5.295 5.333v3.79l1.44-1.44V5.95c.02-2.147 1.775-3.893 3.932-3.912Z" }, null, -1), a = [
  n,
  l
];
function d(r, s) {
  return t(), o("svg", c, [...a]);
}
const h = { render: d };
export {
  h as default,
  d as render
};
